import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { AlertModalComponent } from './alert-modal.component';
import { ButtonModule } from '../button/button.module';


@NgModule({
    declarations: [AlertModalComponent],
    imports: [CommonModule, MaterialModule, ButtonModule, RouterModule],
    exports: [AlertModalComponent],
})
export class AlertModule {
}

